

























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Native from "@/common/Native";
import request from "@/api/yunyang/index";
import {
  IHouseItem,
  IJobDetail,
  ISwiperDetail,
  IJobDetailRes
} from "@/api/yunyang/types";
import {
  Toast,
  Swipe as vanSwipe,
  SwipeItem as vanSwipeItem,
  Image as vanImage
} from "vant";
import Base from "@/template/public/Base.vue";
import indexRequest from "@/api/index";
import AppPrompt from "@/components/AppPrompt.vue";
import { wxChatShare } from "@/common/wechat";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    vanSwipe,
    vanSwipeItem,
    vanImage,
    AppPrompt
  }
})
export default class housedetail extends Base {
  current: number = 0;
  private appId: string = "";
  private id: string = "";
  private isOpenInApp: boolean = false;
  public request: any = new indexRequest();
  detail: IJobDetail = {
    id: "",
    name: "",
    nature: "",
    scale: "",
    synopsis: "",
    position: "",
    description: "",
    salary: "",
    numberPeople: "",
    workmode: "",
    telephone: "",
    address: "",
    publicTime: "",
    education: "",
    demandExp: "",
    imageUrls: []
  };
  swiperData: Array<ISwiperDetail> = [];
  beforeCreate() {
    document.title = "招聘详情";
  }
    // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
    document.title = "招聘详情";
  }
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.id = (this.$route.query.id as string) || "";
    this.isOpenInApp = ZWY_CLOUD.isOpenInApp();

    document.title = "招聘详情";
    if (ZWY_CLOUD.isOpenInApp()) {
      // 设置标题
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "招聘详情",
        isShowMoreBtn: "1"
      });
    }

    this.getDetail();
    this.getShareInfo(this.appId);
  }
  setWxConfig() {
    wxChatShare(
      this.detail.name,
      this.detail.position,
      window.location.href,
      this.swiperData[0].url
    );
  }
  onChange(index: number) {
    this.current = index;
  }
  getDetail() {
    return request
      .getJobDetail(this.appId, this.id)
      .then((res: IJobDetailRes) => {
        if (res.code >= 0 && res.data) {
          this.detail = res.data;
          this.swiperData = res.data ? res.data.imageUrls : [];
          this.setWxConfig();

          if (ZWY_CLOUD.isOpenInApp()) {
            // 设置标题
            ZWY_CLOUD.topBarConfig({
              isShowTop: 1,
              isShowBackBtn: 1,
              isShowTitle: "招聘详情",
              isShowMoreBtn: "1"
            });
            document.title = "招聘详情";
          }
          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, res.data);
              this.dataSource = false;
            }
          });
        }
      });
  }
  callTel() {
    window.location.href = "tel:" + this.detail.telephone;
  }
}
